import React, { useState } from "react";
import WatchIcon from "@mui/icons-material/Watch";
import SearchInput from "../../../components/SearchInput/SearchInput";
import SecondaryEmailsSection from "./SecondaryEmailsSection";

const DeviceAssignmentSection = ({
  mergedDevices,
  assignDevices,
  errors,
  formData,
  numberOfUsers,
  onToggleDevice,
  onChangeDescription,
  // Secondary email props
  secondaryEmails,
  newSecondaryEmail,
  secondaryEmailError,
  handleNewSecondaryEmailChange,
  handleAddSecondaryEmail,
  handleDeleteSecondaryEmail,
  handleEditSecondaryEmail,
  editingIndex,
  editingEmail,
  setEditingEmail,
  handleSaveEditSecondaryEmail,
  handleCancelEditSecondaryEmail,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredDevices = (mergedDevices || []).filter((device) =>
    device.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="form-section device-assignment-section">
      <div className="form-section-header">
        <div className="form-section-header-left">
          <h4 className="form-section-title">Assign Devices</h4>
          <p className="form-section-subtitle">Select devices to allocate user slots automatically.</p>
        </div>
        <div className="form-section-header-right">
          <div className="slots-badge">
            <span className="slots-badge-label">Total Slots</span>
            <span className="slots-badge-value">{numberOfUsers || 0}</span>
          </div>
        </div>
      </div>

      <div className="hp-form-container_formdetails_bottom">
        <div className="hp-form-container_formdetails_bottom_section">
          <div className="hp-form-container_formdetails_bottom_section_left">
            <SearchInput
              className="device-search-input-wrapper"
              name="deviceSearch"
              placeholder="Search devices by name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <div className="device-grid-container">
              {filteredDevices.length > 0 ? (
                <div className="device-cards-grid">
                  {filteredDevices.map((device) => {
                    const checked = assignDevices.some(
                      (d) => String(d.value) === String(device.value)
                    );
                    const displaySlots = checked
                      ? (assignDevices.find(
                          (d) => String(d.value) === String(device.value)
                        )?.slots ?? device.slots)
                      : device.slots;

                    return (
                      <label
                        key={device.value}
                        className={`device-card-item${checked ? " selected" : ""}`}
                      >
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={(e) => onToggleDevice(device, e.target.checked)}
                          aria-label={device.label}
                          className="device-card-checkbox"
                        />
                        <div className="device-card-details">
                          <span className="device-card-name" title={device.label}>
                            {device.label}
                          </span>
                          <span className="device-card-slots">
                            {displaySlots} slots
                          </span>
                        </div>
                        <WatchIcon className="device-card-icon" />
                      </label>
                    );
                  })}
                </div>
              ) : (
                <div className="device-empty-state">
                  <WatchIcon className="empty-icon" />
                  <p>
                    {searchTerm
                      ? `No devices match "${searchTerm}"`
                      : "No devices available"}
                  </p>
                </div>
              )}
            </div>
            {errors.assignDevices && (
              <span className="error device-error">{errors.assignDevices}</span>
            )}
          </div>

          <div className="hp-form-container_formdetails_bottom_section_right">
            <div className="description-field-group">
              <label htmlFor="description" className="description-label">Description</label>
              <textarea
                id="description"
                title="Description"
                name="description"
                value={formData.description}
                onChange={onChangeDescription}
                placeholder="Enter your Description"
                rows={4}
                className="description-textarea"
              />
              {errors.description && (
                <span className="error description-error">{errors.description}</span>
              )}
            </div>

            <div className="emails-field-group" style={{ marginTop: "24px" }}>
              <SecondaryEmailsSection
                secondaryEmails={secondaryEmails}
                newSecondaryEmail={newSecondaryEmail}
                error={secondaryEmailError}
                onChangeNewEmail={(e) => handleNewSecondaryEmailChange(e.target.value)}
                onAddEmail={handleAddSecondaryEmail}
                onDeleteEmail={handleDeleteSecondaryEmail}
                onEditEmail={handleEditSecondaryEmail}
                editingIndex={editingIndex}
                editingEmail={editingEmail}
                setEditingEmail={setEditingEmail}
                onSaveEditEmail={handleSaveEditSecondaryEmail}
                onCancelEditEmail={handleCancelEditSecondaryEmail}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeviceAssignmentSection;
